
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29.8 29.8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".64","fill":"none","stroke":"#fff","stroke-width":"5","stroke-linejoin":"round","d":"M21 8.8l-16.9 17"}}),_c('path',{attrs:{"opacity":".64","fill":"#fff","d":"M4.7 28.7L0 29.8l1.1-4.7z"}}),_c('path',{attrs:{"opacity":".64","fill":"none","stroke":"#fff","stroke-width":"8","stroke-linejoin":"round","d":"M27 2.8l-4.4 4.4"}})])
          )
        }
      }
    